import * as Constants from '../common/constants'

class UserService {
    getAccessToken = () => {
        let store = JSON.parse(localStorage.getItem(Constants.HBB_STORE_NAME))
        // console.log(store.user)
        if (store && store.user && store.user.token) {
            return store.user.token
        } else {
            console.warn('No token found')
            return null
        }
    }
}

export default new UserService()


// WEBPACK FOOTER //
// ./src/services/services.js